import { GetterTree } from 'vuex';
import { RootState } from '@/interface/store/';
import { Profile } from '@/interface/store/profile';

export const getters: GetterTree<Profile, RootState> = {
  getterUserId: (state) => state.userId,
  getterUser: (state) => state.user,
  getterAvatar: (state) => state.avatar,
  getterAlarm: (state) => {
    return {
      orderRequestUpdated: state.emailSettings.orderRequestUpdated,
      orderRequestAccepted: state.emailSettings.orderRequestAccepted,
      receiveCommentNotifications: state.settings.receiveCommentNotifications,
      subscribedToNewsletters: state.subscribedToNewsletters,
    };
  },
  getterCreditCards: (state) => state.creditCardList,
  getterCreditCardItem: (state) => state.creditCardItem,
};
